import baseAuth from "@/staticData/baseAuthEnum";

//TODO 记得把权限补全
/**
 * 路由全局权限对应关系
 * auth必须为数组
 * type:1-基础权限,2-继承权限
 */
export default {
    //首页
    "index"                             : {auth: [], type:1},
    "home"                              : {auth: [baseAuth.HASCOMPANY], type:1},
    "join-company-step"                 : {auth: [baseAuth.HASNOTCOMPANY], type:1},
    "detail"                            : {auth: [baseAuth.HASCOMPANY], type:1},
    "form"                              : {auth: [baseAuth.HASCOMPANY], type:1},
    "unprocessed"                       : {auth: [baseAuth.HASCOMPANY], type:1},
    "urgentUnprocessed"                 : {auth: [baseAuth.HASCOMPANY], type:1},
    "atUnprocessed"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "project-search"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    "carrier-search"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    "company-search"                    : {auth: [baseAuth.HASCOMPANY], type:1},

    // 企业
    "enterprise"                        : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-all"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-all-whole"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-all-search"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-all-detail"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-add"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-edit"                   : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-focus"                  : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-focus-whole"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-focus-update"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-focus-search"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-integral"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-integral-water"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-report"                 : {auth: [baseAuth.HASCOMPANY,baseAuth.APPROVE_ENTERPRISE], type:1},
    "enterprise-report-waitreview"      : {auth: [baseAuth.HASCOMPANY,baseAuth.APPROVE_ENTERPRISE], type:1},
    "enterprise-report-reviewed"        : {auth: [baseAuth.HASCOMPANY,baseAuth.APPROVE_ENTERPRISE], type:1},
    "enterprise-report-allreview"       : {auth: [baseAuth.HASCOMPANY,baseAuth.APPROVE_ENTERPRISE], type:1},
    "enterprise-report-allreport"       : {auth: [baseAuth.HASCOMPANY,baseAuth.APPROVE_ENTERPRISE], type:1},
    "enterprise-report-detail"          : {auth: [baseAuth.HASCOMPANY,baseAuth.APPROVE_ENTERPRISE], type:1},
    "enterprise-recycled"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-recycled-whole"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "enterprise-recycled-search"        : {auth: [baseAuth.HASCOMPANY], type:1},
    // 企业账户
    "enterprise-account"                : {auth: [baseAuth.HASCOMPANY,baseAuth.ENTERPRISE_ACCOUNT_CONFIG], type:1},
    "enterprise-account-whole"          : {auth: [baseAuth.HASCOMPANY,baseAuth.ENTERPRISE_ACCOUNT_CONFIG], type:1},
    "enterprise-ordinary"               : {auth: [baseAuth.HASCOMPANY,baseAuth.ENTERPRISE_ACCOUNT_CONFIG], type:1},
    "enterprise-ban"                    : {auth: [baseAuth.HASCOMPANY,baseAuth.ENTERPRISE_ACCOUNT_CONFIG], type:1},
    "enterprise-account-detail"         : {auth: [baseAuth.HASCOMPANY,baseAuth.ENTERPRISE_ACCOUNT_CONFIG], type:1},

    //土地
    "land"                              : {auth: [baseAuth.HASCOMPANY], type:1},
    //土地项目录入
    "land-item-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //土地项目编辑
    "land-item-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //全部土地项目
    "land-item-all"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-all-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-all-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-all-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-all-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-all-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-all-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //关注土地项目
    "land-item-focus"                   : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-whole"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-recent"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-atme"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-meat"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-reply"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-search"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-focus-update"            : {auth: [baseAuth.HASCOMPANY], type:1},
    //重点接洽的土地项目
    "land-item-important"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-important-whole"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-important-recent"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-important-atme"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-important-meat"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-important-reply"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-important-search"        : {auth: [baseAuth.HASCOMPANY], type:1},
    //接洽中的土地
    "land-item-contacting"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-contacting-whole"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-contacting-recent"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-contacting-atme"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-contacting-meat"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-contacting-reply"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-contacting-search"       : {auth: [baseAuth.HASCOMPANY], type:1},
    //暂缓跟进土地项目
    "land-item-pause"                  : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-pause-whole"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-pause-recent"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-pause-atme"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-pause-meat"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-pause-reply"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-pause-search"           : {auth: [baseAuth.HASCOMPANY], type:1},
    //成功土地项目
    "land-item-success"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-success-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-success-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-success-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-success-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-success-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-success-search"         : {auth: [baseAuth.HASCOMPANY], type:1},
    //全体成功土地项目
    "land-item-allsuccess"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-allsuccess-whole"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-allsuccess-recent"      : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-allsuccess-atme"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-allsuccess-meat"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-allsuccess-reply"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-allsuccess-search"      : {auth: [baseAuth.HASCOMPANY], type:1},
    //土地项目公海
    "land-item-sea"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-sea-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-sea-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-sea-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-sea-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-sea-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-sea-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //土地项目回收站
    "land-item-recycled"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-recycled-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-recycled-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-recycled-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-recycled-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-recycled-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "land-item-recycled-search"         : {auth: [baseAuth.HASCOMPANY], type:1},

    //土地载体录入
    "land-carrier-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //土地载体编辑
    "land-carrier-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //土地全部载体
    "land-carrier-all"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-all-detail"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //土地关注载体
    "land-carrier-focus"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-focus-update"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //土地回收载体
    "land-carrier-recycled"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-recycled-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-recycled-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-recycled-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-recycled-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-recycled-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "land-carrier-recycled-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //厂房
    "factory"                           : {auth: [baseAuth.HASCOMPANY], type:1},
    //厂房项目录入
    "factory-item-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //厂房项目编辑
    "factory-item-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //全部厂房项目
    "factory-item-all"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-all-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-all-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-all-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-all-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-all-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-all-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //关注厂房项目
    "factory-item-focus"                   : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-whole"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-recent"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-atme"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-meat"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-reply"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-search"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-focus-update"            : {auth: [baseAuth.HASCOMPANY], type:1},
    //重点接洽的厂房项目
    "factory-item-important"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-important-whole"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-important-recent"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-important-atme"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-important-meat"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-important-reply"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-important-search"        : {auth: [baseAuth.HASCOMPANY], type:1},
    //接洽中的厂房
    "factory-item-contacting"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-contacting-whole"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-contacting-recent"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-contacting-atme"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-contacting-meat"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-contacting-reply"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-contacting-search"       : {auth: [baseAuth.HASCOMPANY], type:1},
    //暂缓跟进厂房项目
    "factory-item-pause"                  : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-pause-whole"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-pause-recent"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-pause-atme"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-pause-meat"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-pause-reply"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-pause-search"           : {auth: [baseAuth.HASCOMPANY], type:1},
    //成功厂房项目
    "factory-item-success"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-success-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-success-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-success-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-success-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-success-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-success-search"         : {auth: [baseAuth.HASCOMPANY], type:1},
    //全体成功厂房项目
    "factory-item-allsuccess"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-allsuccess-whole"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-allsuccess-recent"      : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-allsuccess-atme"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-allsuccess-meat"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-allsuccess-reply"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-allsuccess-search"      : {auth: [baseAuth.HASCOMPANY], type:1},
    //厂房项目公海
    "factory-item-sea"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-sea-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-sea-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-sea-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-sea-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-sea-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-sea-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //厂房项目回收站
    "factory-item-recycled"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-recycled-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-recycled-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-recycled-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-recycled-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-recycled-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-item-recycled-search"         : {auth: [baseAuth.HASCOMPANY], type:1},

    //厂房载体录入
    "factory-carrier-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //厂房载体编辑
    "factory-carrier-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //厂房全部载体
    "factory-carrier-all"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-all-detail"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //厂房关注载体
    "factory-carrier-focus"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-focus-update"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //厂房回收载体
    "factory-carrier-recycled"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-recycled-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-recycled-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-recycled-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-recycled-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-recycled-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "factory-carrier-recycled-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //仓库
    "warehouse"                           : {auth: [baseAuth.HASCOMPANY], type:1},
    //仓库项目录入
    "warehouse-item-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //仓库项目编辑
    "warehouse-item-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //全部仓库项目
    "warehouse-item-all"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-all-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-all-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-all-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-all-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-all-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-all-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //关注仓库项目
    "warehouse-item-focus"                   : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-whole"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-recent"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-atme"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-meat"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-reply"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-search"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-focus-update"            : {auth: [baseAuth.HASCOMPANY], type:1},
    //重点接洽的仓库项目
    "warehouse-item-important"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-important-whole"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-important-recent"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-important-atme"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-important-meat"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-important-reply"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-important-search"        : {auth: [baseAuth.HASCOMPANY], type:1},
    //接洽中的仓库
    "warehouse-item-contacting"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-contacting-whole"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-contacting-recent"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-contacting-atme"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-contacting-meat"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-contacting-reply"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-contacting-search"       : {auth: [baseAuth.HASCOMPANY], type:1},
    //暂缓跟进仓库项目
    "warehouse-item-pause"                  : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-pause-whole"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-pause-recent"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-pause-atme"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-pause-meat"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-pause-reply"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-pause-search"           : {auth: [baseAuth.HASCOMPANY], type:1},
    //成功仓库项目
    "warehouse-item-success"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-success-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-success-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-success-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-success-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-success-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-success-search"         : {auth: [baseAuth.HASCOMPANY], type:1},
    //全体成功仓库项目
    "warehouse-item-allsuccess"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-allsuccess-whole"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-allsuccess-recent"      : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-allsuccess-atme"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-allsuccess-meat"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-allsuccess-reply"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-allsuccess-search"      : {auth: [baseAuth.HASCOMPANY], type:1},
    //仓库项目公海
    "warehouse-item-sea"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-sea-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-sea-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-sea-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-sea-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-sea-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-sea-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //仓库项目回收站
    "warehouse-item-recycled"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-recycled-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-recycled-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-recycled-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-recycled-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-recycled-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-item-recycled-search"         : {auth: [baseAuth.HASCOMPANY], type:1},

    //仓库载体录入
    "warehouse-carrier-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //仓库载体编辑
    "warehouse-carrier-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //仓库全部载体
    "warehouse-carrier-all"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-all-detail"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //仓库关注载体
    "warehouse-carrier-focus"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-focus-update"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //仓库回收载体
    "warehouse-carrier-recycled"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-recycled-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-recycled-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-recycled-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-recycled-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-recycled-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "warehouse-carrier-recycled-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //写字楼
    "officebuilding"                           : {auth: [baseAuth.HASCOMPANY], type:1},
    //写字楼项目录入
    "officebuilding-item-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //写字楼项目编辑
    "officebuilding-item-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //全部写字楼项目
    "officebuilding-item-all"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-all-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-all-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-all-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-all-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-all-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-all-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //关注写字楼项目
    "officebuilding-item-focus"                   : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-whole"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-recent"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-atme"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-meat"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-reply"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-search"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-focus-update"            : {auth: [baseAuth.HASCOMPANY], type:1},
    //重点接洽的写字楼项目
    "officebuilding-item-important"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-important-whole"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-important-recent"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-important-atme"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-important-meat"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-important-reply"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-important-search"        : {auth: [baseAuth.HASCOMPANY], type:1},
    //接洽中的写字楼
    "officebuilding-item-contacting"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-contacting-whole"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-contacting-recent"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-contacting-atme"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-contacting-meat"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-contacting-reply"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-contacting-search"       : {auth: [baseAuth.HASCOMPANY], type:1},
    //暂缓跟进写字楼项目
    "officebuilding-item-pause"                  : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-pause-whole"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-pause-recent"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-pause-atme"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-pause-meat"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-pause-reply"            : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-pause-search"           : {auth: [baseAuth.HASCOMPANY], type:1},
    //成功写字楼项目
    "officebuilding-item-success"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-success-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-success-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-success-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-success-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-success-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-success-search"         : {auth: [baseAuth.HASCOMPANY], type:1},
    //全体成功写字楼项目
    "officebuilding-item-allsuccess"             : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-allsuccess-whole"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-allsuccess-recent"      : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-allsuccess-atme"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-allsuccess-meat"        : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-allsuccess-reply"       : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-allsuccess-search"      : {auth: [baseAuth.HASCOMPANY], type:1},
    //写字楼项目公海
    "officebuilding-item-sea"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-sea-whole"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-sea-recent"              : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-sea-atme"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-sea-meat"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-sea-reply"               : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-sea-search"              : {auth: [baseAuth.HASCOMPANY], type:1},
    //写字楼项目回收站
    "officebuilding-item-recycled"                : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-recycled-whole"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-recycled-recent"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-recycled-atme"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-recycled-meat"           : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-recycled-reply"          : {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-item-recycled-search"         : {auth: [baseAuth.HASCOMPANY], type:1},

    //写字楼载体录入
    "officebuilding-carrier-add"                     : {auth: [baseAuth.HASCOMPANY], type:1},
    //写字楼载体编辑
    "officebuilding-carrier-edit"                    : {auth: [baseAuth.HASCOMPANY], type:1},
    //写字楼全部载体
    "officebuilding-carrier-all"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-all-detail"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //写字楼关注载体
    "officebuilding-carrier-focus"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-focus-update"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //写字楼回收载体
    "officebuilding-carrier-recycled"                  :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-recycled-whole"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-recycled-recent"           :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-recycled-atme"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-recycled-meat"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-recycled-reply"            :   {auth: [baseAuth.HASCOMPANY], type:1},
    "officebuilding-carrier-recycled-search"           :   {auth: [baseAuth.HASCOMPANY], type:1},

    //单位
    "company"                           :   {auth: [], type:1},
    //加入单位
    "join-company"                      :   {auth: [baseAuth.HASNOTCOMPANY], type:1},
    //单位基本资料
    "company-base-info"                 :   {auth: [baseAuth.HASCOMPANY], type:1},
    //单位详情
    "companyinfo"                       :   {auth: [baseAuth.HASCOMPANY], type:1},
    //编辑单位园区
    "editcompany"                       :   {auth: [baseAuth.HASCOMPANY,baseAuth.EDIT_COMPANY_INFO], type:1},
    //编辑单位其他类型
    "edit-other-company"                :   {auth: [baseAuth.HASCOMPANY,baseAuth.EDIT_COMPANY_INFO], type:1},
    //单位成员
    "company-member-info"               :   {auth: [baseAuth.HASCOMPANY], type:1},
    //单位成员
    "company-member-list"               :   {auth: [baseAuth.HASCOMPANY], type:1},
    //单位成员信息
    "company-member-detail"             :   {auth: [baseAuth.HASCOMPANY], type:1},
    //单位成员名片
    "company-member-card-record"        :   {auth: [baseAuth.HASCOMPANY,baseAuth.WATCH_CARD_RECORD], type:1},
    //添加单位成员
    "company-member-more"               :   {auth: [baseAuth.HASCOMPANY,baseAuth.ADD_USER], type:1},
    //单位分组修改
    "company-group"                     :   {auth: [baseAuth.HASCOMPANY, baseAuth.EDIT_COMPANY_GROUP], type:1},
    //标签管理
    "company-tag"                       :   {auth: [baseAuth.HASCOMPANY, baseAuth.TAB_MANAGE], type:1},
    //标签分类
    "company-tag-type"                  :   {auth: [baseAuth.HASCOMPANY, baseAuth.TAB_MANAGE], type:1},
    //标签设置
    "company-tag-options"               :   {auth: [baseAuth.HASCOMPANY,baseAuth.TAB_MANAGE], type:1},
    //项目进度管理
    "company-item"                      :   {auth: [baseAuth.HASCOMPANY,baseAuth.ITEM_PROGRESS_MANAGE], type:1},
    //项目进度管理
    "company-item-land"                 :   {auth: [baseAuth.HASCOMPANY,baseAuth.ITEM_PROGRESS_MANAGE], type:1},
    "company-item-factory"              :   {auth: [baseAuth.HASCOMPANY,baseAuth.ITEM_PROGRESS_MANAGE], type:1},
    //载体进度管理
    "company-carry"                     :   {auth: [baseAuth.HASCOMPANY,baseAuth.CARRIER_PROGRESS_MANAGE], type:1},
    //载体进度管理
    "company-carry-land"                :   {auth: [baseAuth.HASCOMPANY,baseAuth.CARRIER_PROGRESS_MANAGE], type:1},
    "company-carry-factory"             :   {auth: [baseAuth.HASCOMPANY,baseAuth.CARRIER_PROGRESS_MANAGE], type:1},
    //查看单位名片统计
    "company-card-record"               :   {auth: [baseAuth.HASCOMPANY,baseAuth.WATCH_CARD_RECORD], type:1},
    //附件分类管理
    "company-file-config"               :   {auth:[baseAuth.HASCOMPANY,baseAuth.SET_FILE_CATEGORY],type:1},
    //行政区划管理
    "company-administrative-area"       :   {auth:[baseAuth.HASCOMPANY,baseAuth.SET_ADMINISTRATIVE_AREA],type:1},
    //所属区域管理
    "company-belong-area"               :   {auth:[baseAuth.HASCOMPANY,baseAuth.SET_BELONG_AREA],type:1},
    //项目来源管理
    "company-item-origin"               :   {auth:[baseAuth.HASCOMPANY,baseAuth.SET_ITEM_ORIGIN],type:1},
    //专业类别管理
    "company-profession-category"       :   {auth:[baseAuth.HASCOMPANY,baseAuth.SET_PROFESSION_CATEGORY],type:1},
    //企业区域管理
    "company-area-setting"              :   {auth : [baseAuth.HASCOMPANY,baseAuth.SET_COMPANY_AREA],type : 1},


    //个人中心
    "usercenter"                        : {auth: [], type:1},
    "usercenter-info"                   : {auth: [], type:1},
    "usercenter-images"                 : {auth: [baseAuth.HASCOMPANY], type:1},
    "usercenter-password"               : {auth: [], type:1},
    "usercenter-business-cards"         : {auth: [baseAuth.HASCOMPANY], type:1},
    "usercenter-messages"               : {auth: [], type:1},
    //数据
    "datas"                            : {auth: [baseAuth.DATA_MODULE_ENTRY], type:1},
    "mydata"                           : {auth: [baseAuth.DATA_MODULE_ENTRY], type:1},
    "overalldata"                      : {auth: [baseAuth.DATA_MODULE_ENTRY], type:1},
    "subscribedata"                    : {auth: [baseAuth.DATA_MODULE_ENTRY], type:1},
    "powerdata"                    : {auth: [baseAuth.DATA_MODULE_ENTRY], type:1},
}



// WEBPACK FOOTER //
// ./src/staticData/routeAuthEnum.js